import { useContext, useEffect, useState } from "react";
import { eENTITY, ePrivileges } from "../../../utils/enum";
import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "./entity.module.css";
import CustomerDataList from "./customer-list";
import { TContext, TPrivilege } from "../../../types/config";

function EntityList() {
  const context: TContext = useContext(UserContext);
  const [activeEntity, setActiveEntity] = useState<string>("");

  useEffect(() => {
    setActiveEntity(
      Utils.isUserHasAccess(
        context.user?.privilegeList as TPrivilege[],
        ePrivileges.VIEWCUSTOMER
      )
        ? eENTITY.CUSTOMER
        : ""
    );
  }, [context?.user]);

  const clearQueryParams = () => {
    const baseUrl = window.location.origin + window.location.pathname;
    window.history.replaceState(null, "", baseUrl); // Replace URL without query params
  };

  return (
    <div>
      <div className={styles.parentContainer}>
        {/* Check if user has permission to view customer menu */}
        {Utils.isUserHasAccess(
          context.user?.privilegeList as TPrivilege[],
          ePrivileges.VIEWCUSTOMER
        ) && (
          <div
            className={`${styles.tab} ${
              activeEntity === eENTITY.CUSTOMER ? styles.activeTab : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveEntity(eENTITY.CUSTOMER);
            }}
          >
            <span
              className={
                activeEntity === eENTITY.CUSTOMER
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Customers
            </span>
          </div>
        )}
        {/* Check if user has permission to view service partner menu */}
      </div>
      <div>
        {activeEntity === eENTITY.CUSTOMER ? <CustomerDataList /> : null}
      </div>
    </div>
  );
}

export default EntityList;
